import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { ModalDialogService } from '../../../core/services/modal-dialog.service';
import { ModalResult } from '../../../core/interfaces/modal-result';
import { ResultState } from '../../../core/enums/result-state.enum';

@Component({
  selector: 'app-confirmation-dialog',
  template: `
    <div class="modal-header lead">
      {{ dialogParameters().title }}
    </div>
    <div class="modal-body h-100 d-flex flex-column justify-content-center">
      <div>{{ dialogParameters().message }}</div>

      @if (dialogParameters().emphasizedText) {
        <div class="lead text-left mt-4 color-tk">
          {{ dialogParameters().emphasizedText }}
        </div>
      }
    </div>
    <div class="d-flex gap-2">
      @if (dialogParameters().showCancellationButton) {
        <button
          type="button"
          class="button-modal no w-100"
          (click)="closeInternal(states.Cancelled)">
          {{ dialogParameters()?.customCancellationLabel || 'SHARED.CANCEL' | translate }}
        </button>
      }

      <button
        type="button"
        class="button-modal btn-primary w-100"
        (click)="closeInternal(states.Confirmed)">
        {{ dialogParameters()?.customConfirmationLabel || 'SHARED.OK' | translate }}
      </button>
    </div>
  `,
  host: { class: 'd-flex flex-column h-100' },
  imports: [TranslatePipe],
})
export class ConfirmationDialogComponent {
  modalDialogService = inject(ModalDialogService);
  dialog = inject(DialogRef);

  dialogParameters = this.modalDialogService.dialogParameters;

  public states = ResultState;

  public closeInternal(state: ResultState): void {
    const result: ModalResult = { data: null, state };
    this.dialog.close(result);
  }
}
